export default class NewsModel {
    constructor({id, title, content, news, is_active, language, created_by, created_by_name, created_on}) {
        this.id = id;
        this.title = title;
        this.content = content;
        this.news = news;
        this.language = language;
        this.status = is_active;
        this.created_by = created_by;
        this.created_by_name = created_by_name;
        this.created_on = created_on;
    }
}